import { motion } from "framer-motion";
import { Quote } from "lucide-react";

const TESTIMONIALS = [
  {
    name: "Tommaso (20 anni)",
    text: [
      "Da quando ho iniziato la mia vita è migliorata davvero tanto, quindi se ci penso ogni piccolo passo avanti è già una vittoria. A volte mi fisso troppo sui risultati e mi dimentico di guardare quanto sono migliorato nel complesso. Grazie davvero.",
    ],
  },
  {
    name: "Monica",
    image: "/testimonials/monica-prima-dopo.webp",
    beforeAfter: true,
    text: [
      "Sono super contenta del lavoro che stiamo facendo insieme ma… il merito è anche tuo, della tua pazienza e della tua PROFESSIONALITÀ… e adesso avanti tutta!",
    ],
  },
  {
    name: "Paola (62 anni)",
    text: [
      "Sono riuscita a tornare a sciare dopo anni di inattività e di tutore al ginocchio: mi hai dato la possibilità di tornare a fare una delle cose che più amo al mondo.",
    ],
  },
  {
    name: "Daniela (59 anni)",
    text: [
      "Mi sento più sicura adesso nel compiere gesti che stavo smettendo di fare per paura.",
    ],
  },
  {
    name: "Sonia",
    image: "/testimonials/sonia.webp",
    text: [
      "Mi sono sentita ascoltata e accompagnata nel percorso. Sono riuscita a perdere 8 kg di grasso mantenendo la massa magra, grazie all'approccio multidisciplinare!",
    ],
  },
];

const SORTED = [...TESTIMONIALS].sort((a, b) => Number(Boolean(b.image)) - Number(Boolean(a.image)));

export const Testimonials = () => (
  <div data-testid="testimonials" className="mt-20 md:mt-28">
    <p className="eyebrow mb-4">Chi ci sta lavorando</p>
    <h3 className="mb-10 max-w-4xl font-display text-3xl font-900 uppercase leading-none md:text-5xl">
      Ogni piccolo passo <span className="text-[#c4dcca]">è già una vittoria.</span>
    </h3>
    <div className="grid gap-4">
      {SORTED.map((t, i) => (
        <motion.figure key={t.name} data-testid={`testimonial-${i}`}
          initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.15 }}
          transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
          className={`relative grid gap-8 border-l-2 border-[#98bfa2] bg-[#0b120e] p-7 md:p-12 ${t.image ? "md:grid-cols-[1fr_minmax(0,340px)] md:items-center" : ""}`}>
          <div>
            <Quote size={36} className="text-[#98bfa2]" aria-hidden="true" />
            <blockquote className="mt-6 max-w-4xl space-y-4 text-lg leading-relaxed text-[#f4f7f5] md:text-2xl">
              {t.text.map((p) => <p key={p.slice(0, 20)}>{p}</p>)}
            </blockquote>
            <figcaption className="mt-8 font-mono text-xs uppercase tracking-widest text-[#c4dcca]">— {t.name}</figcaption>
          </div>
          {t.image && (
            <div data-testid={`testimonial-${i}-photo`} className="relative overflow-hidden border border-[rgba(152,191,162,0.25)]">
              <img src={t.image} alt={t.beforeAfter ? `${t.name}: prima e dopo il percorso` : t.name} loading="lazy" className="h-auto w-full" />
              {t.beforeAfter && (<>
                <span className="absolute left-3 top-3 bg-[#050807]/80 px-2 py-1 font-mono text-xs uppercase tracking-widest text-[#f4f7f5]">Prima</span>
                <span className="absolute right-3 top-3 bg-[#98bfa2] px-2 py-1 font-mono text-xs uppercase tracking-widest text-[#050807]">Dopo</span>
              </>)}
            </div>
          )}
        </motion.figure>
      ))}
    </div>
    <p data-testid="testimonials-privacy-note" className="mt-6 max-w-3xl text-sm leading-relaxed text-[#a3b1aa]">
      Alcune persone non hanno piacere a mostrarsi in foto: ho rispettato la loro volontà e la loro privacy.
    </p>
  </div>
);
